import React, { useState, useEffect } from 'react';
import emailjs from '@emailjs/browser';
import './Contact.css';
import usePageTitle from '../hooks/usePageTitle';
import borderImage from '../assets/border.png';

const Contact: React.FC = () => {
  usePageTitle('Contact');
  
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      // EmailJS credentials
      const serviceId = 'service_lektlsp';
      const templateId = 'template_tvi78m8';
      const publicKey = 'U0FBd1aHtz9Snx1QE';

      const templateParams = {
        from_name: formData.name,
        from_email: formData.email,
        phone: formData.phone,
        message: formData.message,
        to_name: 'Primus',
        to_email: 'irenej923@gmail.com'
      };

      await emailjs.send(serviceId, templateId, templateParams, publicKey);
      
      setSubmitStatus('success');
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('EmailJS error:', error);
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contact-page">
      <div className="contact-container">
        <div className="contact-header">
          <h1 className="contact-title">Contact Us</h1>
          <img src={borderImage} alt="" className="contact-decorative-line" />
        </div>
        
        <div className="contact-content">
          <div className="contact-info">
            <p className="contact-intro">
              If you were referred by one of our members or are new, feel free to write a letter—short or long—with any questions that you might have.
            </p>
            <p className="contact-thanks">Thank you.</p>
            
            <div className="contact-details">
              <h3>PRIMUS</h3>
              <p>857-389-9775</p>
              <p>irene@theprimusedu.com</p>
            </div>
          </div>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="name"
              value={formData.name}
              onChange={handleChange}
              className="form-input"
              required
            />
            
            <div className="form-row">
              <input
                type="email"
                name="email"
                placeholder="email"
                value={formData.email}
                onChange={handleChange}
                className="form-input"
                required
              />
              <input
                type="tel"
                name="phone"
                placeholder="phone number"
                value={formData.phone}
                onChange={handleChange}
                className="form-input"
              />
            </div>
            
            <textarea
              name="message"
              placeholder="message"
              value={formData.message}
              onChange={handleChange}
              className="form-textarea"
              rows={8}
              required
            />
            
            <button type="submit" className="submit-button" disabled={isSubmitting}>
              {isSubmitting ? 'Sending...' : 'Submit'}
            </button>

            {submitStatus === 'success' && (
              <div className="status-message success">
                Thank you! Your message has been sent successfully.
              </div>
            )}

            {submitStatus === 'error' && (
              <div className="status-message error">
                Sorry, there was an error sending your message. Please try again or contact us directly.
              </div>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;